// EXEMPT
import { GAME_SHORT_NAMES } from "@/app/constants.mjs";
import { GAME_SYMBOL_RUST } from "@/app/upcoming-game-definitions.mjs";
import type {
  ChampionBuild,
  Entry,
  RelatedEntries,
  TFTBestItem,
} from "@/data-models/contentful.mjs";
import { GAME_SYMBOL_APEX } from "@/game-apex/definition-symbol.mjs";
import { GAME_SYMBOL_CS2 } from "@/game-csgo/definition-symbol.mjs";
import { GAME_SYMBOL_DEADLOCK } from "@/game-deadlock/definition-symbol.mjs";
import { GAME_SYMBOL_FORTNITE } from "@/game-fortnite/definition-symbol.mjs";
import { GAME_SYMBOL_LOL } from "@/game-lol/definition-symbol.mjs";
import { GAME_SYMBOL_MARVEL_RIVALS } from "@/game-marvel-rivals/definition-symbol.mjs";
import { GAME_SYMBOL_MINECRAFT } from "@/game-minecraft/definition.mjs";
import { GAME_SYMBOL_OVERWATCH2 } from "@/game-ow2/definition.mjs";
import { GAME_SYMBOL_ROCKETLEAGUE } from "@/game-rocket/definition-symbol.mjs";
import { GAME_SYMBOL_TFT } from "@/game-tft/definition-symbol.mjs";
import { GAME_SYMBOL_VAL } from "@/game-val/definition-symbol.mjs";

export type ContentfulStateConfig = {
  entry: Record<string, Entry>; // EntryID
  entryInline: Record<string, ChampionBuild | TFTBestItem>;
  related: RelatedEntries;
  canonical: Record<string, string>; // CanonicalURL, EntryId
};

const PLACEMENT_TAGS = {
  // Website specific
  PROBUILDS: "probuilds",
  // Special placement tags: Controls where content would appear in the homepage
  TILES_GRID: "tilesGrid",
  TILES_LIST: "tilesList",
  TOP_FOLD: "topFold",
  INTRO: "intro", // Deprecated (will remove integration if I find no purpose for it since we're still conducting R&D for features)
};

// These are special tags that control article placement and appearance
export const CONTENTFUL_TAGS: Record<string, string> & typeof PLACEMENT_TAGS = {
  // Game tags: Controls which game the content would appear in the homepage
  [GAME_SHORT_NAMES[GAME_SYMBOL_MINECRAFT]]: "minecraft",
  [GAME_SHORT_NAMES[GAME_SYMBOL_MARVEL_RIVALS]]: "marvelRivals",
  // [GAME_SHORT_NAMES[GAME_SYMBOL_MINECRAFT]]: "pathOfExile2", // No game symbol yet
  [GAME_SHORT_NAMES[GAME_SYMBOL_ROCKETLEAGUE]]: "rocketLeague",
  [GAME_SHORT_NAMES[GAME_SYMBOL_OVERWATCH2]]: "overwatch2",
  [GAME_SHORT_NAMES[GAME_SYMBOL_RUST]]: "rust",
  [GAME_SHORT_NAMES[GAME_SYMBOL_DEADLOCK]]: "deadlock",
  [GAME_SHORT_NAMES[GAME_SYMBOL_APEX]]: "apexLegends",
  [GAME_SHORT_NAMES[GAME_SYMBOL_CS2]]: "counterStrike2",
  [GAME_SHORT_NAMES[GAME_SYMBOL_VAL]]: "valorant",
  [GAME_SHORT_NAMES[GAME_SYMBOL_FORTNITE]]: "fortnite",
  [GAME_SHORT_NAMES[GAME_SYMBOL_TFT]]: "teamfightTactics",
  [GAME_SHORT_NAMES[GAME_SYMBOL_LOL]]: "leagueOfLegends",
  ...PLACEMENT_TAGS,

  NEWS: "news",
  PATCH_NOTES: "patchNotes",
};
